import type { GetSchedule } from "@/api_types/teacher";
import FetchService from "@/services/fetch.service";
import { useConferenceStore } from "@/stores/teacher/conference";
import { createApp } from "vue";
import SchedulePrintVue from "./SchedulePrint.vue";
import vuetify from "@/plugins/vuetify";
import { sort } from "@/utils/sort";

export const printSchedule = async () => {
  const confStore = useConferenceStore();
  if (!confStore.selected?.conference_days) return;
  const res = await Promise.all(
    sort(confStore.selected.conference_days, (i) => i.start).map(async (d) => {
      const team =
        "team" in (confStore.selected || {}) ? `&team_uid=${confStore.selected?.team?.uid}` : "";
      const res = await FetchService.fetchData(
        "/schedule?conference_days_id=" + d.conference_days_id + team,
        "get"
      );
      if (res) {
        // Filter breaks based on current tab: exclude breaks (flag === 'N') in agenda mode
        // In schedule mode, show all items (matching agendaCard.vue behavior)
        const filtered = confStore.tab === 'agenda' 
          ? res.filter((i) => i.flag && i.flag !== 'N')
          : res; // Include all items in schedule mode, including breaks
        return { agenda: filtered as GetSchedule[], conferenceDay: d };
      }
      return [];
    })
  );

  const newWin = window.open("about:blank", "_blank")!;
  newWin.document.title = "event schedule";
  const meta = newWin.document.createElement("meta");
  meta.setAttribute("name", "viewport");
  meta.setAttribute("content", "width=device-width, initial-scale=1.0");

  const icons = newWin.document.createElement("link");
  icons.setAttribute(
    "href",
    "https://cdn.jsdelivr.net/npm/@mdi/font@7.2.96/css/materialdesignicons.min.css"
  );
  icons.setAttribute("rel", "stylesheet");
  // <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  newWin.document.head.appendChild(meta);
  newWin.document.head.appendChild(icons);
  const app = createApp(SchedulePrintVue, {
    agendas: res,
    conference: confStore.selected,
    win: newWin
  }).use(vuetify);
  const container = newWin.document.createElement("div");
  container.classList.add("app");
  newWin.document.body.appendChild(container);
  app.mount(container);
  setTimeout(() => newWin.print(), 500);
};
